import Http from './http';

export interface IPortabilityInsuranceItem {
	batchId: string;
	rowNumber: number;
	clientDocument: string;
	clientName: string;
	clientEmail: string | null;
	clientPhone: string | null;
	rentValue: number | null;
	rentAdditional: number | null;
	propertyAddress: string | null;
	propertyZipCode: string | null;
	propertyCity: string | null;
	propertyState: string | null;
	propertyType: number | null;
	paymentMethod: number | null;
	success: boolean;
	errorMessage: string | null;
	caseId: string | null;
	processedAt: string | null;
}

export class PortabilityToolsService {
	static httpClient = Http.create(import.meta.env.VITE_GW_SERVICE);
	static async analyzeBatch(file: File): Promise<Blob> {
		const form = new FormData();
		form.append('excelFile', file);

		const response = await this.httpClient.post('policy/analyze-batch', form, {
			headers: { 'Content-Type': 'multipart/form-data' },
			responseType: 'blob',
		});
		return response.data as Blob;
	}

	static async insuranceGuarantee(file: File): Promise<IPortabilityInsuranceItem[]> {
		const form = new FormData();
		form.append('xlsxFile', file);

		const response = await this.httpClient.post<{ data: IPortabilityInsuranceItem[] }>(
			'portability/insurance-guarantee',
			form,
			{ headers: { 'Content-Type': 'multipart/form-data' } },
		);
		return response.data.data || [];
	}
}

export default PortabilityToolsService;
